import colors from './colors'

export default {
  container: (provided) => {
    return {
      ...provided,
      width: '500px',
      maxWidth: '100%',
      height: '44px'
    }
  },
  control: (provided) => {
    return {
      ...provided,
      height: '44px',
      boxShadow: 'none',
      borderColor: `${colors.rock} !important`
    }
  },
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: `${state.data.backgroundColor} !important`,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      width: 'fit-content',
      maxWidth: '475px',
      height: '32px',
      margin: '6px 5px 6px 10px',
      lineHeight: '32px',
      padding: '0 10px',
      borderRadius: '4px',
      cursor: 'pointer',
      color: state.data.color || colors.white,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      fontWeight: '400',
      opacity: state.isFocused ? '0.75' : '1'
    }
  },
  singleValue: (provided, state) => {
    return {
      ...provided,
      backgroundColor: `${state.data.backgroundColor} !important`,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      width: 'fit-content',
      maxWidth: '475px',
      height: '32px',
      margin: '0',
      lineHeight: '32px',
      padding: '0 10px',
      borderRadius: '4px',
      cursor: 'pointer',
      color: state.data.color || colors.white,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      fontSize: '14px',
      fontWeight: '400',
      opacity: state.isFocused ? '0.75' : '1'
    }
  },
  placeholder: (provided, state) => {
    return {
      ...provided,
      color: state.data && state.data.color || colors.black,
      backgroundColor: state.data && state.data.backgroundColor || colors.white,
      fontSize: '14px',
      fontWeight: '400'
    }
  },
  indicatorSeparator: (provided) => {
    return {
      ...provided,
      display: 'none'
    }
  },
  indicatorsContainer: (provided, state) => {
    return {
      ...provided,
      height: '100%',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none'
    }
  },
  valueContainer: (provided) => {
    return {
      ...provided,
      height: '100%'
    }
  },
  noOptionsMessage: (provided) => {
    return {
      ...provided,
      fontSize: '14px',
      fontWeight: '500',
      color: colors.black
    }
  },
  groupHeading: provided => ({
    ...provided,
    color: colors.dove,
    fontSize: '13px',
    fontWeight: '300',
    padding: '0 20px'
  })
}
